import { catalogsSyncTypes } from "redux/reducers/catalogsSync/catalogsSyncTypes";
import { api_get, PROYECT } from "services/api";
import { startRequestComp, stopRequestComp, setSnackbar } from "../search/searchActions";

const { 
  SYNC_CATALOGS_SYNC,
  CLEAR_CATALOGS_SYNC,
} = catalogsSyncTypes

export const doCatalogsSync = (close) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/support/catalogs`
  return async( dispatch ) => {
    dispatch(startRequestComp('loadingCatalogsSync'))
    await api_get(url).then(resp => {
      let payload = {}
      let isError = ''
      const response = resp?.reduce((acc, curr) => {
        if(curr?.error) {
          isError += `${curr?.error}\n`
        } else {
          const entities = Object.keys(curr)
          entities.forEach(key => {
            if(!acc[key]) acc[key] = 0
            acc[key] += curr[key]
          })
        }
        return acc
      }, {})
      if(isError) {
        payload = {
          isError: true,
          catalogsSyncLog: isError,
          catalogsSync: {}
        }
      } else {
        payload = {
          isError: false,
          catalogsSyncLog: '',
          catalogsSync: response
        }
        dispatch(setSnackbar("Los catálogos se han sincronizado con éxito", "success"))
      }
      dispatch({
        type: SYNC_CATALOGS_SYNC,
        payload
      })
    }).catch(error => {
      dispatch({
        type: SYNC_CATALOGS_SYNC,
        payload: {
          isError: true,
          catalogsSyncLog: error,
          catalogsSync: {}
        }
      })
      dispatch(setSnackbar("Error al sincronizar"))
    })
    close(false)
    dispatch(stopRequestComp('loadingCatalogsSync'))
  }
}

export const clearCatalogsSync = () => ({
  type: CLEAR_CATALOGS_SYNC,
})